import React, { useEffect, useMemo, useRef, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import Header from "../../../layouts/Header.js";
import {
  DriveAdd,
  DriveUpdate,
  FetchSpireFolderDocuments,
  DeleteDriveFolderOrFile,
} from "../../../redux/actions/action.js";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { API_URL } from "../../../redux/constants/type.js";
import { Tooltip, Empty, Progress } from "antd";
import {
  FilePdfTwoTone,
  FileWordTwoTone,
  FileTextTwoTone,
  FileTwoTone,
  EyeOutlined,
  LoadingOutlined,
  ArrowDownOutlined,
  FileTextOutlined,
  FilePdfOutlined,
  FileJpgOutlined,
  FileImageOutlined,
  FileWordOutlined,
  FilePptOutlined,
  FileExcelOutlined,
  JavaScriptOutlined,
} from "@ant-design/icons";
import { getFilePreview } from "../../../utils/filePreview/filePreview";
import FilePreviewModal from "../../../utils/filePreview/FilePreviewModal";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import moment from "moment";
import threeDots from "../../../assets/icons/Kebab Calculations.svg";
import PlusImg from "../../../assets/icons/plus-circle-white.svg";
import send from "../../../assets/icons/send.svg";
import bin from "../../../assets/icons/Bin.svg";
import AIicon from "../../../assets/icons/AIicon.svg";
import PlusImgDotted from "../../../assets/icons/plus-dotted-blue-icon.svg";
import PlusImg2 from "../../../assets/icons/plus-circle2.svg";
import searchicon from "../../../assets/icons/search.svg";
import doc from "../../../assets/extension/doc.svg";
import pdf from "../../../assets/extension/pdf.svg";
import file from "../../../assets/extension/file.svg";
import text from "../../../assets/extension/text.svg";
import msWord from "../../../assets/extension/msWord.svg";
import javaScript from "../../../assets/extension/javaScript.svg";
import DragDropSpireAi from "./DragDropSpireAi-3.js";
import roundFileSize from "../../../utils/Documents/roundFileSize";
import "../../../assets/styles/local/SpireAI.css";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";
import {
  getChatRooms,
  addIndividualGroups,
} from "../../../redux/actions/chatActions";

import { SPIRE_GPT, SPIRE_ACADEMY, findAssistantRoom } from "../../../utils/helpers/chatAssistants";
import { message as chatNotification } from "antd";

const SpireAiUpdate = () => {
  const dispatch = useDispatch();
  const [Ankit] = useAutoAnimate();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const hidden_Input_File = useRef(null);
  const eyeRef = useRef({});
  const userid = window.localStorage.getItem("userid");
  const { folderID } = useParams();

  const fetchSpireFolderDocumentsRes = useSelector(
    (state) => state.user.fetchSpireFolderDocumentsRes,
  );
  const filesInsertDocToS3Res = useSelector(
    (state) => state.user.filesInsertDocToS3Res,
  );
  const driveUpdateFolderRes = useSelector(
    (state) => state.user.driveUpdateFolderRes,
  );
  const deleteDriveFolderORFileRes = useSelector(
    (state) => state.user.deleteDriveFolderORFileRes,
  );
  const addDocRootRes = useSelector((state) => state.user.addDocRootRes);
  const ajitSpireJsonApiRes = useSelector(
    (state) => state.user.ajitSpireJsonApiRes,
  );

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Spire_AI").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  const [filePreview, setFilePreview] = useState(null);

  const [webHookLoader, setWebHookLoader] = useState({});

  const [fetchFolderData, setFetchFolderData] = useState([]);
  const [childrenShow, setChildrenShow] = useState(false);
  const [childrenFolderData, setChildrenFolderData] = useState([]);
  const [childrenFolderID, setChildrenFolderID] = useState("");
  const [kebabMenuShow, setKebabMenuShow] = useState(false);
  const [searchFolderName, setSearchFolderName] = useState("");

  useEffect(() => {
    dispatch(FetchSpireFolderDocuments(folderID));
  }, [
    dispatch,
    folderID,
    addDocRootRes,
    driveUpdateFolderRes,
    deleteDriveFolderORFileRes,
    ajitSpireJsonApiRes,
  ]);

  useEffect(() => {
    if (addDocRootRes?.status) {
      setWebHookLoader((prev) => {
        const updated = { ...prev };
        addDocRootRes.data?.forEach((doc) => {
          updated[doc.documentid] = true;
        });
        return updated;
      });
    }
  }, [addDocRootRes]);

  useEffect(() => {
    if (ajitSpireJsonApiRes?.statusCode === 200) {
      setWebHookLoader((prev) => {
        const updated = { ...prev };
        ajitSpireJsonApiRes?.body?.data?.forEach((doc) => {
          updated[doc.documentid] = false;
        });
        return updated;
      });
    }
  }, [ajitSpireJsonApiRes]);

  useEffect(() => {
    if (fetchSpireFolderDocumentsRes?.length > 0) {
      console.log("asc22", fetchSpireFolderDocumentsRes);

      const rootFolder = fetchSpireFolderDocumentsRes;

      let totalChildrenData = fetchSpireFolderDocumentsRes?.map((x) => [
        ...x?.children,
        ...x?.Children,
      ]);

      console.log("asc23 childrens", totalChildrenData);
      console.log(
        "asc24 childrens map",
        totalChildrenData[0]?.map((x) => x.Id),
      );
      // if (childrenShow) {
      //   setFetchFolderData(totalChildrenData[0]);
      // } else {
      //   setFetchFolderData(rootFolder);
      // }
      setFetchFolderData(totalChildrenData[0]);
    }
  }, [fetchSpireFolderDocumentsRes, childrenShow, childrenFolderID]);

  const extensionType = (data = "file", data2) => {
    let fileExtension =
      data === "folder" || data2 === "folder"
        ? "📁"
        : data === "txt" || data === "file"
          ? "📄"
          : data === "pdf"
            ? "🟥"
            : data === "doc"
              ? "📘"
              : data === "js"
                ? "📜"
                : "?";
    return fileExtension;
  };

  const extensionType26 = (data = "file", data2) => {
    let fileExtension =
      data === "folder" || data2 === "folder" ? (
        "📁"
      ) : data === "txt" || data === "file" ? (
        <img src={text} alt="" width={30} /> || "📄"
      ) : data === "pdf" ? (
        <img src={pdf} alt="" width={30} />
      ) : data === "doc" ? (
        <img src={doc} alt="" width={30} />
      ) : data === "js" ? (
        <img src={javaScript} alt="" width={30} />
      ) : (
        <img src={file} alt="" width={30} /> || "?"
      );
    return fileExtension;
  };

  const extensionType2 = (type = "file", type2) => {
    let fileExtension =
      type2 === "folder" ? (
        "📁"
      ) : type === "txt" || type === "file" ? (
        <FileTextOutlined style={{ fontSize: "26px", color: "#C43E1C" }} />
      ) : type === ".csv" ? (
        <FileTextOutlined style={{ fontSize: "26px", color: "#107C41 " }} />
      ) : type === ".xls" || type === ".xlsx" || type === ".xlsm" ? (
        <FileExcelOutlined style={{ fontSize: "26px", color: "#107C41" }} />
      ) : type === ".docx" || type === "doc" ? (
        <FileWordOutlined style={{ fontSize: "26px", color: "#2B579A" }} />
      ) : type === ".ppt" || type === "pptx" ? (
        <FilePptOutlined style={{ fontSize: "26px", color: "#C43E1C" }} />
      ) : type === ".jpg" ||
        type === ".jpeg" ||
        type === ".png" ||
        type === ".gif" ? (
        <FileImageOutlined style={{ fontSize: "26px", color: "#E17B34 " }} />
      ) : type === ".pdf" ? (
        <FilePdfOutlined style={{ fontSize: "26px", color: "#FF0000" }} />
      ) : type === ".svg" ? (
        <FileImageOutlined style={{ fontSize: "26px", color: "#E17B34" }} />
      ) : type === ".js" ? (
        <JavaScriptOutlined style={{ fontSize: "26px", color: "#F7DF1E" }} />
      ) : (
        <FileTextOutlined style={{ fontSize: "26px", color: "#C43E1C" }} />
      );

    return fileExtension;
  };

  const openingAssistantChat = useRef(false);
  const goToChat = async (assistant = SPIRE_GPT) => {
    if (openingAssistantChat.current) return;
    openingAssistantChat.current = true;
    try {
      const rooms = await dispatch(getChatRooms(userid));
      let roomId = findAssistantRoom(rooms, assistant)?.groupid;
      if (!roomId) {
        const result = await dispatch(addIndividualGroups(userid, "", [
          { groupmember: assistant.userId },
          { groupmember: userid },
        ]));
        roomId = result?.status && result?.data?.[0]?.groupid;
        if (!roomId) throw new Error(result?.message || "Conversation creation failed");
      }
      history.push(`/chat?room=${roomId}`);
    } catch (error) {
      console.error(`Error opening ${assistant.name} chat:`, error);
      chatNotification.error(`Unable to open ${assistant.name} chat. Please try again.`);
    } finally {
      openingAssistantChat.current = false;
    }
  };

  const showTooltipComp = (item) => {
    return (
      <div>
        {item.Status === "Ready" ? (
          <>
            <div
              className="spireText5 d-flex gap-3 py-1 px-3 pointer"
              onClick={() => {
                goToChat();
              }}
            >
              <p className="spireText1 fw-medium">SpireGPT</p>
              <img src={send} alt="" width={18} />
            </div>
            <div
              className="spireText5 d-flex gap-3 py-1 px-3 pointer"
              onClick={() => goToChat(SPIRE_ACADEMY)}
            >
              <p className="spireText1 fw-medium">Spire Academy</p>
              <img src={send} alt="" width={18} />
            </div>
          </>
        ) : item.Status === "Structuring Data" ? (
          <div>
            <div className="spireText1 d-flex gap-2 pt-2">
              <p className="spireText4">2</p>
              <p className="mb-0">Structuring data</p>
            </div>
            <p className="spireText2 pt-1">
              Text being extracted from images and segment the document to
              understand its content. This ensures the information is
              well-organized and ready for processing.
            </p>
            <p className="spireText3 pt-2 pe-1 text-end">Step 2/4</p>
          </div>
        ) : item.Status === "Creating AI Database" ? (
          <div>
            <div className="spireText1 d-flex gap-2 pt-2">
              <p className="spireText4">4</p>
              <p className="mb-0">Creating AI Datanase</p>
            </div>
            <p className="spireText2 pt-1">
              The extracted data is converted into vectors (mathematical
              representations) and enriched with metadata such as document type,
              date, or relevant tags. All information is stored in a scalable
              vector database to enable fast and efficient searching.
            </p>
            <p className="spireText3 pt-2 pe-1 text-end">Step 4/4</p>
          </div>
        ) : item.Status === "Layout analysis" ? (
          <div>
            <div className="spireText1 d-flex gap-2 pt-2">
              <p className="spireText4">3</p>
              <p className="mb-0">Layout analysis</p>
            </div>
            <p className="spireText2 pt-1">
              The document’s structure is being analyzed and classified. This
              makes it easier to search and filter information later, based on
              various components such as headings, tables, or text blocks.
            </p>
            <p className="spireText3 pt-2 pe-1 text-end">Step 3/4</p>
          </div>
        ) : item.Status === "Data received" ? (
          <div>
            <div className="spireText1 d-flex gap-2 pt-2">
              <p className="spireText4">1</p>
              <p className="mb-0">Data received</p>
            </div>
            <p className="spireText2 pt-1">
              The document is securely stored in the AI environment of the Spire
              Connect database, making it easily accessible for further
              processing.
            </p>
            <p className="spireText3 pt-2 pe-1 text-end">Step 1/4</p>
          </div>
        ) : item.Status === "Parked" ? (
          <div>
            <div className="spireText1 d-flex gap-2 pt-2">
              <p className="spireText4">1</p>
              <p className="mb-0">Parked</p>
            </div>
            <p className="spireText2 pt-1">
              The document has been securely stored and parked, pending review,
              validation, or further processing.
            </p>
            <p className="spireText3 pt-2 pe-1 text-end d-none">Step 1/4</p>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  // Callback function to receive data from child start.
  const [dataFromChild, setDataFromChild] = useState([]);
  console.log("asc child Data", dataFromChild);

  const handleDataFromChild = (data) => {
    setDataFromChild(data);
  };
  // Callback function to receive data from child end.

  return (
    <>
      <Header
        setQuery={setSearchFolderName}
        leftComponent={
          <div className="headerContainer">
            <div
              className="dashboardTitle pointer"
              onClick={() => history.push("/Spire-AI")}
            >
              {/* AI Drive */}
              {t("AI Drive")}
            </div>
          </div>
        }
      />

      <div className="ps-4 col-11 col-lg-4 d-none">
        <section className="asc_Search_Icon_Search mx-2 w-100">
          <input
            id="asc_input"
            className="asc_Search_Input w-100"
            // placeholder="Search..."
            placeholder={t("Search...")}
            value={searchFolderName}
            onChange={(e) => setSearchFolderName(e.target.value)}
          />
          <img src={searchicon} alt="" className="asc_searchicon me-2" />
        </section>
      </div>

      <div
        className="mx-3"
        style={{
          position: "relative",
          overflow: "auto",
          height: "350px",
          maxHeight: "350px",
        }}
      >
        <table className="table">
          <thead>
            <tr className="tableHeading-NewInvoice z-1">
              <th style={{ width: "2%" }}></th>
              <th style={{ width: "35%" }}>
                {/* AI Folder Name */}
                {t("AI Folder Name")}
              </th>
              <th style={{ width: "12%" }}>
                {/* Creation Date */}
                {t("Creation Date")}
              </th>
              <th style={{ width: "20%" }}>
                {/* Owner */}
                {t("Owner")}
              </th>
              <th style={{ width: "10%" }}>
                {/* File Size */}
                {t("File Size")}
              </th>
              <th>
                {/* AI Status */}
                {t("AI Status")}
              </th>
              <th>
                {/* Logo */}
                <img
                  src={AIicon}
                  alt=""
                  className="opacity-50"
                  style={{
                    width: "20px",
                    height: "25px",
                  }}
                />
              </th>
              <th></th>
              <th></th>
            </tr>
          </thead>

          <tbody
            className="tabLine"
            style={{ borderTop: "1px dotted" }}
            ref={Ankit}
          >
            {fetchFolderData
              ?.filter((x) =>
                x.name?.toLowerCase().includes(searchFolderName?.toLowerCase()),
              )
              ?.sort((a, b) => (a.type === "folder" ? -1 : 1))
              // alphabetically sorting like abcdefg...👇
              // ?.sort((a, b) => a.type.localeCompare(b.type))
              ?.map((item, index) => {
                return (
                  <tr
                    className="trHover"
                    style={{ borderBottom: "1px dotted" }}
                    key={index}
                    onClick={() => {
                      setChildrenFolderID(item.Id);
                    }}
                  >
                    <td></td>
                    <td className="foldertxt">
                      <div
                        className="d-flex align-items-baseline gap-2 pointer"
                        onClick={() => {
                          if (item.type === "folder") {
                            setChildrenShow(true);
                            history.push(`/Spire-AI-folder/${item.Id}`);
                          }
                        }}
                      >
                        <span className="fs-5">
                          {/* {item.type === "folder" ? "📁" : "📄"} */}
                          {extensionType2(item.extension, item.type)}
                        </span>
                        {/* <span>{item.name}</span> */}
                        <span>
                          {/* <a
                            href={item.link}
                            target="_blank" // comment if download.
                            rel="noopener noreferrer" // comment if download.
                            // download // attribute to download.
                            style={{ color: "unset", textDecoration: "none" }}
                          >
                            {item.name}
                          </a> */}
                          <span
                            onClick={() => {
                              eyeRef.current[item.Id]?.click();
                            }}
                          >
                            {item.name}
                          </span>
                        </span>
                      </div>
                    </td>
                    <td className="foldertxt">
                      {moment(item.createdat).format("DD.MM.YYYY") || "_"}
                    </td>
                    <td className="foldertxt">{item.Ownername || "_"}</td>
                    <td className="foldertxt">
                      {roundFileSize(item.size) || "_"}
                    </td>

                    {/* <td className="foldertxt">{item.Status || "_"}</td> */}

                    <td className="foldertxt">
                      {item.type === "file" ? (
                        !webHookLoader[item.Id] && item?.Status ? (
                          <Tooltip
                            title={showTooltipComp(item)}
                            color={"white"}
                            overlayInnerStyle={{
                              color: "black",
                              fontWeight: "500",
                            }}
                          >
                            {item.Status}
                          </Tooltip>
                        ) : (
                          <LoadingOutlined />
                        )
                      ) : (
                        "_"
                      )}
                    </td>
                    <td className="foldertxt">
                      <Progress
                        type="circle"
                        size={22}
                        strokeWidth={25}
                        percent={
                          item.Status === "Ready"
                            ? 100
                            : item.Status === "Structuring Data"
                              ? 60
                              : item.Status === "Creating AI Database"
                                ? 80
                                : item.Status === "Layout analysis"
                                  ? 40
                                  : item.Status === "Data received"
                                    ? 20
                                    : 0
                        }
                        format={() => ""} // inner text hide karega.
                        strokeColor="green" // circle ka color green karega.
                        // strokeColor={item.percent > 50 ? "green" : "orange"}
                        trailColor="#ddd"
                        // format={(percent) =>
                        //   percent === 100 ? (
                        //     <div
                        //       style={{
                        //         background: "green",
                        //         borderRadius: "50%",
                        //         display: "flex",
                        //         alignItems: "center",
                        //         justifyContent: "center",
                        //         color: "white",
                        //         fontSize: "12px",
                        //         fontWeight: 900,
                        //       }}
                        //     >
                        //       <CheckOutlined />
                        //     </div>
                        //   ) : (
                        //     ""
                        //   )
                        // } // ✅ 100 pe tick mark
                      />
                    </td>
                    <td className="foldertxt">
                      <img
                        src={bin}
                        alt=""
                        className="opacity-50 pointer"
                        style={{
                          width: "15px",
                          height: "15px",
                        }}
                        onClick={() => {
                          if (item.type === "file") {
                            dispatch(
                              DeleteDriveFolderOrFile(item.Id, "rootdoc"),
                            );
                          } else {
                            dispatch(
                              DeleteDriveFolderOrFile(item.Id, "folder"),
                            );
                          }
                        }}
                      />
                    </td>

                    <td className="foldertxt p-0 pointer">
                      {item?.type === "file" && (
                        <>
                          <ArrowDownOutlined
                            className="mx-3"
                            onClick={() => {
                              window.open(
                                item.link,
                                "_blank",
                                "noopener,noreferrer",
                              );
                            }}
                          />

                          <span>
                            <EyeOutlined
                              ref={(el) => (eyeRef.current[item.Id] = el)}
                              onClick={() => {
                                setFilePreview(
                                  getFilePreview({
                                    // file: file, // local upload file
                                    url: item.link,
                                    type: item.link.split(".").pop(),
                                    name: item.name,
                                  }),
                                );
                              }}
                            />
                          </span>
                        </>
                      )}
                    </td>

                    <td className="foldertxt position-relative d-none">
                      <img
                        src={threeDots}
                        alt=""
                        className="pointer ps-1"
                        // style={{
                        //   transform: "rotate(90deg)",
                        //   marginLeft: "20px",
                        // }}
                        onClick={() => {
                          setKebabMenuShow(!kebabMenuShow);
                          // setKebabMenuShow(true);
                        }}
                      />

                      {kebabMenuShow && childrenFolderID === item.Id && (
                        <ClickAwayListener
                          onClickAway={() => setKebabMenuShow(false)}
                        >
                          <div className="kebabDiv position-absolute">
                            <h6
                              className="pointer"
                              onClick={() => {
                                if (item.type === "file") {
                                  dispatch(
                                    DeleteDriveFolderOrFile(item.Id, "rootdoc"),
                                  );
                                } else {
                                  dispatch(
                                    DeleteDriveFolderOrFile(item.Id, "folder"),
                                  );
                                }
                              }}
                            >
                              {/* Delete */}
                              {t("Delete")}
                            </h6>
                          </div>
                        </ClickAwayListener>
                      )}
                    </td>
                  </tr>
                );
              })}
            {fetchFolderData.length > 0 &&
              fetchFolderData.filter((x) =>
                x.name?.toLowerCase().includes(searchFolderName.toLowerCase()),
              ).length === 0 && (
                <tr>
                  <td colSpan="8">
                    <div className="noDataDisplay">
                      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                    </div>
                  </td>
                </tr>
              )}
          </tbody>
        </table>
      </div>

      <FilePreviewModal
        open={filePreview}
        file={filePreview}
        onClose={() => setFilePreview(null)}
      />

      <DragDropSpireAi childData={handleDataFromChild} />
    </>
  );
};

export default SpireAiUpdate;
